import { createApp, reactive } from 'vue';
import 'primeflex/primeflex.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import '../node_modules/prismjs/themes/prism-coy.css';
import './assets/styles/demo/flag.css';
// import axios from 'axios';

import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import BadgeDirective from 'primevue/badgedirective';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Galleria from 'primevue/galleria';
import InlineMessage from 'primevue/inlinemessage';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import Knob from 'primevue/knob';
import Menu from 'primevue/menu';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Panel from 'primevue/panel';
import Password from 'primevue/password';
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Rating from 'primevue/rating';
import Ripple from 'primevue/ripple';
import Sidebar from 'primevue/sidebar';
import Slider from 'primevue/slider';
import SelectButton from 'primevue/selectbutton';
import SplitButton from 'primevue/splitbutton';
import StyleClass from 'primevue/styleclass';
import TabMenu from 'primevue/tabmenu';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Tag from 'primevue/tag';
import Textarea from 'primevue/textarea';
import Timeline from 'primevue/timeline';
import ToggleButton from 'primevue/togglebutton';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import CodeHighlight from './AppCodeHighlight';

import { createPinia } from 'pinia';
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
// import {useUserStore} from "@/stores/UserStore";

const app = createApp(App);
// app.use(PrimeVue, { ripple: true });

app.use(PrimeVue, {
    ripple: true,
    zIndex: {
        modal: 99990,
        overlay: 99991,
        menu: 99992,
        tooltip: 99993,
        toast: 99999
    }
});

app.use(ToastService);
app.use(router);

const pinia = createPinia();
pinia.use(piniaPluginPersistedState)
app.use(pinia);

// app.config.globalProperties.$appState = reactive({ theme: 'lara-light-teal', dark: false });
app.config.globalProperties.$appState = reactive({ theme: 'lara-light-teal', dark: false });

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Carousel', Carousel);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('Column', Column);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Editor', Editor);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('Galleria', Galleria);
app.component('InlineMessage', InlineMessage);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Knob', Knob);
app.component('Menu', Menu);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('Panel', Panel);
app.component('Password', Password);
app.component('ProgressBar', ProgressBar);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('Sidebar', Sidebar);
app.component('SelectButton', SelectButton);
app.component('Slider', Slider);
app.component('SplitButton', SplitButton);
app.component('TabMenu', TabMenu);
app.component('TabPanel', TabPanel);
app.component('TabView', TabView);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('Timeline', Timeline);
app.component('ToggleButton', ToggleButton);
app.component('Toast', Toast);

app.directive('code', CodeHighlight);
app.directive('badge', BadgeDirective);
app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);

// axios.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('authToken');
//         if (token) {
//             config.headers['Authorization'] = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );
//
// let isRedirecting = false;
//
// axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response && error.response.status === 401 && !isRedirecting) {
//
//             const userStore = useUserStore();
//             const rights = userStore.productRights || '';
//             console.log("[main.js] userStore.productRights = ", rights);
//
//             if (rights.includes('SI')) {
//                 localStorage.removeItem('authToken');
//                 router.push('/siLogin');
//             } else if (rights.includes('IsoGrow')) {
//                 localStorage.removeItem('authToken');
//                 router.push('/isogrowLogin');
//             } else {
//                 localStorage.removeItem('authToken');
//                 router.push('/login');
//             }
//
//             if (userStore.productRights && userStore.productRights.includes('SI')) {
//                 router.push('/iso-grow-login');
//             } else if (userStore.productRights && userStore.productRights.includes('IsoGrow')) {
//                 router.push('/isogrowLogin');
//             } else {
//                 router.push('/login');
//             }
//         }
//         return Promise.reject(error);
//     }
// );
//
// // Make axios globally available
// app.config.globalProperties.$axios = axios;
//
// app.config.errorHandler = (err, vm, info) => {
//     console.error(`💥 Global Error: ${info}`, err);
// };

app.mount('#app');
